/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import axios from 'axios';
import { IdentityContext } from '../IdentityContext';
import queryString from 'query-string';
import { ProjectContext } from '../ProjectContext';

// eslint-disable-next-line react/prop-types
export default function AuthenticatedRoute({ children, location, ...routeProps }) {
  const { project } = useContext(ProjectContext);
  const phUrl = determinePubHubBaseUrl();
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const {
    isAuthenticated,
    setIsAuthenticated,
    setAuthUser,
    authToken,
    setAuthToken
  } = useContext(IdentityContext);
  useEffect(() => {
    (async() => {
      let isAuthenticatedLocal = isAuthenticated;
      if (!isAuthenticated) {
        try {
          let newAuthUser = null;
          const queryParams = queryString.parse(location.search);
          if (queryParams && queryParams.jwt) {
            newAuthUser = await authenticateToken(queryParams.jwt);
            setAuthToken(queryParams.jwt);
          } else if (authToken) {
            newAuthUser = await authenticateToken(authToken);
          }
          if (newAuthUser) {
            isAuthenticatedLocal = true;
            setAuthUser(newAuthUser);
            setIsAuthenticated(isAuthenticatedLocal);
          }
        } catch (err) {
          setIsAuthenticated(false);
          setAuthToken(null);
        }
      }
      // NOTE: authentication process completed (whether previously, now or N/A)
      if (!isAuthenticatedLocal) {
        window.location.replace(`${phUrl}/authentication/signin?returnUrl=${encodeURIComponent(window.location.href)}`);
      } else if (isAuthenticating) {
        setIsAuthenticating(false);
      }
    })();
  });

  const renderIsAuthenticating = (
    <Route {...routeProps}>
      <h2>Authenticating...</h2>
    </Route>
  );
  const loadingProject = (
    <Route {...routeProps}>
      <h2>Loading Project...</h2>
    </Route>
  );
  const renderIsAuthenticated = (
    <Route {...routeProps}>
      {children}
    </Route>
  );
  const renderUnauthenticated = (
    <Route {...routeProps}>
      <h2>ERROR: Not Authenticated</h2>
    </Route>
  );
  if (isAuthenticating) {
    return renderIsAuthenticating;
  }
  if (isAuthenticated) {
    if (!project) {
      return loadingProject;
    }
    return renderIsAuthenticated;
  }
  return renderUnauthenticated;

  async function authenticateToken(token) {
    const url = `${phUrl}/api/auth/token-signin`;
    const response = await axios({
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      url: url
    });
    return response.data;
  }
  function determinePubHubBaseUrl() {
    const hostname = window.location.hostname;
    if (/localhost/.test(hostname)) {
      return 'http://localhost:3000';
      //return 'https://dev.pubhub.studio';
    } else if (/admin-dev/.test(hostname)) {
      return 'https://dev.pubhub.studio';
    } else if (/admin-test/.test(hostname)) {
      return 'https://test.pubhub.studio';
    } else if (/admin-prep/.test(hostname)) {
      return 'https://prep.pubhub.studio';
    } else if (/admin./.test(hostname)) {
      return 'https://pubhub.studio';
    }
  }
}
